import React, { useState } from 'react';
import { truncateFilename } from '../utils';
import { SvgIcon } from '../SvgIcon';
import { $Text } from '../newTypography';
import { getFileMeta } from './fileType';
import { $Container, $SectionTitle, $DocumentList, $DocumentItem, $DocumentLink, $Thumb, $ThumbImage, $ExtBadge, $FileName, $Empty, } from './styles';
const DocumentThumb = ({ document }) => {
    const [imageFailed, setImageFailed] = useState(false);
    const { isImage, extension, iconName } = getFileMeta(document.filename, document.contentType);
    if (isImage && document.url && !imageFailed) {
        return (React.createElement($Thumb, null,
            React.createElement($ThumbImage, { src: document.url, alt: document.filename, onError: () => setImageFailed(true), loading: 'lazy' })));
    }
    return (React.createElement($Thumb, null,
        React.createElement(SvgIcon, { name: iconName, size: 22, color: 'currentColor' }),
        extension && React.createElement($ExtBadge, null, extension)));
};
export const DocumentPreview = ({ title, description, error, errorMsg, documents, onViewDocument }) => (React.createElement($Container, null,
    React.createElement($SectionTitle, { error: error || !!errorMsg }, title),
    (description || errorMsg) &&
        React.createElement($Text, null, errorMsg || description),
    documents?.length ? (React.createElement($DocumentList, null, documents.map((document) => (React.createElement($DocumentItem, { key: document.id },
        React.createElement($DocumentLink, { href: document.url, target: '_blank', rel: 'noopener noreferrer', title: document.filename, onClick: document.url
                ? undefined
                : onViewDocument ? (e) => { e.preventDefault(); onViewDocument(document.id); } : undefined },
            React.createElement(DocumentThumb, { document: document }),
            React.createElement($FileName, null, truncateFilename(document.filename)))))))) : (React.createElement($Empty, null, "No documents available."))));
